"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/empty/style");
var _empty = _interopRequireDefault(require("antd/lib/empty"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/table/style");
var _table = _interopRequireDefault(require("antd/lib/table"));
var _react = _interopRequireDefault(require("react"));
var _api = require("./api");
var _LegacyTable = require("../../LegacyTable");
var _SpinGlobal = _interopRequireDefault(require("../../SpinGlobal/SpinGlobal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AdminGroupReviews = function AdminGroupReviews(_ref) {
  var group = _ref.group;
  var _useGroupReviews = (0, _api.useGroupReviews)(group),
    loadingReviews = _useGroupReviews.loadingReviews,
    reviews = _useGroupReviews.reviews;
  var config = (0, _LegacyTable.groupReviewListConfig)(reviews);
  if (loadingReviews) {
    return /*#__PURE__*/_react.default.createElement(_SpinGlobal.default, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, reviews !== null && reviews !== void 0 && reviews.length ? /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "reviews"
  }, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_table.default, config))) : /*#__PURE__*/_react.default.createElement(_empty.default, {
    image: _empty.default.PRESENTED_IMAGE_SIMPLE
  }));
};
var _default = AdminGroupReviews;
exports.default = _default;